import { c as _c } from "react/compiler-runtime";
import { CurrencyDollarIcon, FoldersIcon, Laptop01Icon, Lightning01Icon, PlusIcon } from '@systemeio/icons';
import { CurrencyEnum } from '@systemeio/types';
import { DigitalProductSection } from 'modules/digital-product/components/digital-product-section';
import { DigitalProductSelectField } from 'modules/digital-product/components/digital-product-select-field';
import { PillRadioGroup } from 'shared/components/pill-radio-group';
import { DigitalProductSourceEnum } from 'modules/digital-product/enums/digital-product-source-enum';
import { useDigitalProduct } from 'modules/digital-product/hooks/use-digital-product';
import { PricePlanRow } from 'modules/digital-product/price-plans/components/price-plan-row';
import { ResourceRow } from 'modules/digital-product/resources/components/resource-row';
import { DigitalProductChangeInterface, DigitalProductId } from 'modules/digital-product/types/digital-product-interface';
import { IconTile } from 'shared/components/icon-tile';
import React, { useEffect, useState } from 'react';
import { Button, FormInput, Modal } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
enum AddProductModeEnum {
  existing = 'existing',
  new = 'new',
}
interface DigitalProductAddModalProps {
  currency: CurrencyEnum;
  isBump?: boolean;
  onAdd: (product: DigitalProductChangeInterface) => void;
  onClose: () => void;
  opened: boolean;
  source: DigitalProductSourceEnum;
}
export function DigitalProductAddModal(t0) {
  const $ = _c(78);
  const {
    currency,
    isBump,
    onAdd,
    onClose,
    opened,
    source
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [mode, setMode] = useState(AddProductModeEnum.existing);
  const [productId, setProductId] = useState();
  const [name, setName] = useState("");
  let t1;
  let t2;
  if ($[0] !== opened) {
    t1 = () => {
      if (!opened) {
        setMode(AddProductModeEnum.existing);
        setProductId(undefined);
        setName("");
      }
    };
    t2 = [opened];
    $[0] = opened;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const {
    data: selectedProduct
  } = useDigitalProduct(productId);
  let t3;
  if ($[3] !== selectedProduct?.pricePlans) {
    t3 = selectedProduct?.pricePlans ?? [];
    $[3] = selectedProduct?.pricePlans;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const pricePlans = t3;
  let t4;
  if ($[5] !== mode || $[6] !== name || $[7] !== selectedProduct) {
    t4 = mode === AddProductModeEnum.existing ? !!selectedProduct : name.trim().length !== 0;
    $[5] = mode;
    $[6] = name;
    $[7] = selectedProduct;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const isReady = t4;
  let t5;
  if ($[9] !== mode || $[10] !== name || $[11] !== onAdd || $[12] !== onClose || $[13] !== selectedProduct) {
    t5 = event => {
      event.preventDefault();
      if (mode === AddProductModeEnum.existing) {
        if (!selectedProduct) {
          return;
        }
        onAdd(selectedProduct);
      } else {
        if (name.trim().length === 0) {
          return;
        }
        onAdd({
          id: null,
          name,
          resources: [],
          pricePlans: [],
          confirmationEmail: null
        });
      }
      onClose();
    };
    $[9] = mode;
    $[10] = name;
    $[11] = onAdd;
    $[12] = onClose;
    $[13] = selectedProduct;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const handleAdd = t5;
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IconTile size="m" tone="gray"><Laptop01Icon /></IconTile>;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t) {
    t7 = t("dashboard.digital_product.add.title");
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t7) {
    t8 = <span>{t7}</span>;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t) {
    t9 = t("dashboard.digital_product.add.description");
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t9) {
    t10 = <span className="text-text-tertiary text-sm font-normal">{t9}</span>;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t8) {
    t11 = <div className="flex items-center gap-4">{t6}<div className="flex flex-col">{t8}{t10}</div></div>;
    $[24] = t10;
    $[25] = t8;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== handleAdd) {
    t12 = <form onSubmit={handleAdd} />;
    $[27] = handleAdd;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t) {
    t13 = t("global.cancel");
    $[29] = t;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== onClose || $[32] !== t13) {
    t14 = <Button type="button" className="tablet:flex-none flex-1" onClick={onClose} variant="secondary" size="md">{t13}</Button>;
    $[31] = onClose;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  const t15 = !isReady;
  let t16;
  if ($[34] !== t) {
    t16 = t("dashboard.funnel.configuration.offer.add_product");
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t15 || $[37] !== t16) {
    t17 = <Button disabled={t15} className="tablet:flex-none flex-1" type="submit" variant="primary" size="md">{t16}</Button>;
    $[36] = t15;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t14 || $[40] !== t17) {
    t18 = <>{t14}{t17}</>;
    $[39] = t14;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t) {
    t19 = t("dashboard.digital_product.add.existing");
    $[42] = t;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <FoldersIcon />;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t19) {
    t21 = {
      id: AddProductModeEnum.existing,
      caption: t19,
      icon: t20
    };
    $[45] = t19;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t) {
    t22 = t("dashboard.digital_product.add.new");
    $[47] = t;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <PlusIcon />;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== t22) {
    t24 = {
      id: AddProductModeEnum.new,
      caption: t22,
      icon: t23
    };
    $[50] = t22;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t21 || $[53] !== t24) {
    t25 = [t21, t24];
    $[52] = t21;
    $[53] = t24;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  let t26;
  if ($[55] !== mode || $[56] !== t25) {
    t26 = <PillRadioGroup options={t25} value={mode} onChange={setMode} />;
    $[55] = mode;
    $[56] = t25;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  let t27;
  if ($[58] !== currency || $[59] !== isBump || $[60] !== mode || $[61] !== name || $[62] !== pricePlans || $[63] !== productId || $[64] !== selectedProduct || $[65] !== source || $[66] !== t) {
    t27 = mode === AddProductModeEnum.existing ? <><DigitalProductSelectField label={t("dashboard.funnel.configuration.offer.digital_product")} required={true} currency={currency} isBump={isBump} source={source} value={productId} onChange={selected => setProductId(selected.id)} onDeleted={() => setProductId(undefined)} />{selectedProduct && selectedProduct.resources.length !== 0 && <DigitalProductSection icon={<Lightning01Icon />} title={t("dashboard.funnel.configuration.common.offer_resources.title")}><div className="flex flex-col gap-2">{selectedProduct.resources.map(_temp)}</div></DigitalProductSection>}{pricePlans.length !== 0 && <DigitalProductSection icon={<CurrencyDollarIcon />} title={t("dashboard.funnel.configuration.offer.price_plans")}><div className="flex flex-col gap-2">{pricePlans.map(_temp2)}</div></DigitalProductSection>}</> : <FormInput label={t("dashboard.funnel.configuration.offer.digital_product_name")} required={true} value={name} onChange={e => setName(e.target.value)} />;
    $[58] = currency;
    $[59] = isBump;
    $[60] = mode;
    $[61] = name;
    $[62] = pricePlans;
    $[63] = productId;
    $[64] = selectedProduct;
    $[65] = source;
    $[66] = t;
    $[67] = t27;
  } else {
    t27 = $[67];
  }
  let t28;
  if ($[68] !== t26 || $[69] !== t27) {
    t28 = <div className="flex flex-col gap-4">{t26}{t27}</div>;
    $[68] = t26;
    $[69] = t27;
    $[70] = t28;
  } else {
    t28 = $[70];
  }
  let t29;
  if ($[71] !== onClose || $[72] !== opened || $[73] !== t11 || $[74] !== t12 || $[75] !== t18 || $[76] !== t28) {
    t29 = <Modal opened={opened} onClose={onClose} title={t11} render={t12} footer={t18}>{t28}</Modal>;
    $[71] = onClose;
    $[72] = opened;
    $[73] = t11;
    $[74] = t12;
    $[75] = t18;
    $[76] = t28;
    $[77] = t29;
  } else {
    t29 = $[77];
  }
  return t29;
}
function _temp2(pricePlan) {
  return <PricePlanRow key={pricePlan.id} className="bg-bg-page" pricePlan={pricePlan} />;
}
function _temp(resource) {
  return <ResourceRow key={resource.id} className="bg-bg-page" resource={resource} />;
}